module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Assortiment")]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.assortiment), function(a) {
    return _c('span', {
      key: a.id,
      staticClass: "list-group-item"
    }, [_vm._v("\n              " + _vm._s(a.naam) + "\n            ")])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Rivkah en Victor")]), _vm._v(" "), _c('p', [_vm._v("Mijn zus Rivkah begon in 2014 met wedstrijden op de weg en daarna in het veld. Ik ben in 2015 in het veld begonnen. ")]), _vm._v(" "), _c('p', [_vm._v("Met onze vader hebben wij in die tijd heel veel ervaring op gedaan.\n          Daarbij hebben we ook heel veel geleerd over technische dingen die bij de jeugd nogal eens mis kunnen gaan.")]), _vm._v(" "), _c('p', [_vm._v("Via deze site bieden wij producten aan waarvan we uit ervaring weten dat die juist voor jeugdrenners handig zijn.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Techniek")]), _vm._v(" "), _c('p', [_vm._v("De jeugd sport vaak in de breedte en daarom hebben wij onderdelen en accessoires voor wielrennen, veldrijden, mountainbiken en baanwielrennen.")]), _vm._v(" "), _c('p', [_vm._v("We helpen ook met het afstellen van fietsen, want juist bij jeugd is iedereen verschillend en kan zelfs een kleine aanpassing al\n        een wereld van verschil opleveren.")]), _vm._v(" "), _c('p', [_vm._v("We helpen ook bij het bepalen van de juiste verzetten in combinatie met de gebruikte banden en wij hebben zelf heel goede ervaringen met het\n        rijden met een enkel blad voor.")]), _vm._v(" "), _c('p', [_vm._v("Kinderen hebben vaak moeite met schakelen en onze ervaring is dat ook daarin allerlei oplossingen bestaan, variërend van kiezen voor de juiste shifter\n        het toepassen van een elektronisch schakelsysteem.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c40f2c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 18
// module chunks = 0